"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_UNIT_MODAL = void 0;
var ADD_UNIT_MODAL = {
  INPUT__NAME: 'addUnitModal-input-name',
  INPUT__ABBREVIATION: 'addUnitModal-input-abbreviation',
  INPUT__QUANTITY: 'addUnitModal-input-quantity',
  BUTTON__TYPE: 'addUnitModal-button-type',
  BUTTON__CANCEL: 'addUnitModal-button-cancel',
  BUTTON__SAVE: 'addUnitModal-button-save'
};
exports.ADD_UNIT_MODAL = ADD_UNIT_MODAL;